import type { CoverageMetricPayload } from "../lib/analysis-api";

/**
 * P01 — apresentação dos estados de cobertura (testável, sem DOM).
 * Os rótulos sempre acompanham o badge: estado nunca depende só de cor.
 */

export const COVERAGE_LEVEL_CLASS: Record<CoverageMetricPayload["level"], string> = {
  ALTA: "badge-success",
  MEDIA: "badge-warning",
  BAIXA: "badge-danger",
  INDISPONIVEL: "badge-neutral",
};

export const COVERAGE_LEVEL_LABEL: Record<CoverageMetricPayload["level"], string> = {
  ALTA: "Alta",
  MEDIA: "Média",
  BAIXA: "Baixa",
  INDISPONIVEL: "Indisponível",
};

export const COVERAGE_TABLE_METRICS = [
  { key: "goals", label: "Gols" },
  { key: "shots", label: "Chutes" },
  { key: "shotsOnTarget", label: "No alvo" },
  { key: "corners", label: "Escanteios" },
  { key: "yellowCards", label: "Cartões" },
  { key: "possession", label: "Posse" },
  { key: "xg", label: "xG" },
] as const;

/** Percentual legível; `null` nunca vira 0%. */
export function formatCoveragePercent(coverage: number | null): string {
  if (coverage === null) return "—";
  return `${(coverage * 100).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}%`;
}

export function coverageLevelLabel(level: CoverageMetricPayload["level"]): string {
  return COVERAGE_LEVEL_LABEL[level] ?? "Indisponível";
}

export function coverageLevelClass(level: CoverageMetricPayload["level"]): string {
  return COVERAGE_LEVEL_CLASS[level] ?? "badge-neutral";
}

/** Somente o proprietário do espaço pode disparar a atualização (o servidor reforça). */
export function canUpdateCoverage(role: string | null | undefined): boolean {
  return role === "owner";
}
